import React,{useMemo} from 'react';
import { Handle,Position } from 'reactflow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Icons from "../Icons";
const isNodeDataComplete = (data,metadata) => {
  if (!metadata) {
    return true;
  }
  for (const field of metadata) {
    if (field.required && (data[field.name] === undefined || data[field.name] === null || data[field.name] === '')) {
      return false;
    }
  }
  return true;
};

const Node =  ({nodeName, data, id,selected,metadata,type,style={}}) => {
  let isComplete = isNodeDataComplete(data,metadata);
  const { name, propertyToCheck, rules = [], defaultOutputHandleId, status } = data;
  // Tạo danh sách các handle ID duy nhất từ rules và default output
  const outputHandleIds = useMemo(() => {
      const handles = new Set();
      rules.forEach(rule => {
          if (rule.outputHandleId && String(rule.outputHandleId).trim() !== '') {
              handles.add(String(rule.outputHandleId).trim());
          }
      });
      if (defaultOutputHandleId && String(defaultOutputHandleId).trim() !== '') {
          handles.add(String(defaultOutputHandleId).trim());
      }
      // Sắp xếp lại nếu cần
      return Array.from(handles).sort((a, b) => {
            const numA = parseInt(a.match(/\d+$/)?.[0]);
            const numB = parseInt(b.match(/\d+$/)?.[0]);
            if (!isNaN(numA) && !isNaN(numB)) return numA - numB;
            if (!isNaN(numA)) return -1;
            if (!isNaN(numB)) return 1;
            return a.localeCompare(b);
      });
  }, [rules, defaultOutputHandleId]);

  let statusClass;
  if(data.disabled){
    statusClass = 'node-disabled';
  }else{
    statusClass = ((data||{}).nodeState||{}).status? `node-status-${((data||{}).nodeState||{}).status}` : 'node-status-pending';
  }
  
  return (
    <div className={`base-node ${statusClass} ${selected ? 'selected-node' : ''}`} style={{ border: '1px solid #ccc', paddingTop: 10, paddingBottom: 10, minWidth: 150, ...style }} >
      <Handle type="target"
        position={Position.Left}
        onConnect={(params) => console.log('handle onConnect', params)}
        isConnectable={true}
      />
      {!isComplete && <div className="node-warning">⚠️</div>} {/* Biểu tượng cảnh báo */}
      
      <div style={{display:"flex",flexDirection:"row",alignItems:"center",justifyContent:"center"}}>
        <FontAwesomeIcon icon={Icons[type] || Icons.default} className="node-icon" style={{color:style.color}} />
        <div style={{ textAlign:"center" }} className="name-node">{nodeName || data.name||"Switch"}</div>
      </div>
    
      <div style={{ position: 'relative',marginTop:5 }}>
          {outputHandleIds.map((handleId, index) => (
              <div key={handleId} style={{ position: 'relative', height: 20, marginBottom: 5 }}>
                  <Handle
                      type="source"
                      position={Position.Right}
                      id={handleId}
                      style={{
                          background: '#555',
                          top: `${(index + 1) * (100 / (outputHandleIds.length + 1))}%`
                      }}
                  />
                  <span style={{
                      position: 'absolute',
                      right: '15px',
                      top: `${(index + 1) * (100 / (outputHandleIds.length + 1))}%`,
                      transform: 'translateY(-50%)',
                      fontSize: '0.7em',
                      color: '#666',
                      background: 'rgba(255, 255, 255, 0.8)',
                      padding: '1px 3px',
                      borderRadius: '2px',
                      pointerEvents: 'none'
                  }}>
                      {handleId}
                  </span>
              </div>
          ))}
      </div>
      {/* Hiển thị trạng thái nếu có */}
      {((data||{}).nodeState||{}).status && <div className="status-node">{((data||{}).nodeState||{}).status}</div>}

    </div>
  );
};

export default Node; 